import "core-js/modules/es.object.assign";
export function stripUndefinedFields(obj) {
  var _obj = Object.assign({}, obj);

  Object.keys(_obj).forEach(k => _obj[k] === undefined && delete _obj[k]);
  return _obj;
}